import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-ai-loader-overlay',
    templateUrl: './ai-loader-overlay.component.html',
    styleUrls: ['./ai-loader-overlay.component.scss'],
    standalone: false
})
export class AiLoaderOverlayComponent implements OnInit {
  ngOnInit(): void {}
}
